import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM16.0658 10.8231C16.3587 10.5302 16.3587 10.0553 16.0658 9.76245C15.773 9.46956 15.2981 9.46956 15.0052 9.76245L11.2929 13.4748L8.99478 11.1767C8.70189 10.8838 8.22702 10.8838 7.93412 11.1767C7.64123 11.4696 7.64123 11.9444 7.93412 12.2373L10.7625 15.0658C11.0554 15.3586 11.5303 15.3586 11.8232 15.0658L16.0658 10.8231Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const SuccessAlternativeOutlined = React.forwardRef(IconComponent);
SuccessAlternativeOutlined.displayName = 'SuccessAlternativeOutlined';

export { SuccessAlternativeOutlined };
